import { Stack, Typography } from "@mui/material";
import BoxIcon from "../assets/png/Boxing.png";
import { isEmpty } from "lodash";

export const Empty = ({ data, title }: any) => (
  <>
    {isEmpty(data) ? (
      <Stack
        sx={{
          width: "100%",
          alignItems: "center",
          justifyContent: "cwnter",
        }}
      >
        <img width={200} height={200} src={BoxIcon} alt="box-icon" />
        <Typography
          fontSize={18}
          fontWeight={700}
          color="secondary.contrastText"
        >
          {title ? title : "Sem resultados"}
        </Typography>
      </Stack>
    ) : null}
  </>
);
